<template>
    <div class="formulario-funcionario">
        <h4 class="header2">Dados Usuário</h4>
        <div class="row">
            <div class="col s6">
                <label class="typo__label">Empresa</label>
                <multiselect
                    v-model="value"
                    :options="company"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :hide-selected="false"
                    open-direction="top"
                    placeholder="Escolha uma empresa"
                    label="empresa_nome_fantasia"
                    track-by="empresa_nome_fantasia"
                    id="empresa_id"
                    @input="onChange($event)"

                ></multiselect>

                <div v-if="empresaSelecionada && empresaSelecionada.empresa_tipo_id == 1" class="mt-2 mb-2">
                    <div class="mb-2">
                        <label><strong>Selecione a empresa parceira:</strong></label>
                        <label class="label">Isso implicará em alterações no relatório do diagnóstico de necessidades</label>
                    </div>
                    <div v-for="empresa in empresasParceiras" :key="`empresa-${empresa.empresa_id}`">
                        <input type="checkbox" name="empresa" :id="`empresa-${empresa.empresa_id}`" v-model="formData.empresas_ids"  :value="empresa.empresa_id"/>
                        <label :for="`empresa-${empresa.empresa_id}`">{{ empresa.empresa_nome_fantasia }}</label>
                        <!-- {{ empresa }} -->
                    </div>
                </div>

            </div>
            <div class="col s6">
                <label for="funcionario_cargo_id">Cargo</label>
                <select class="browser-default" v-model="formData.funcionario_cargo_id" id="funcionario_cargo_id">
                    <option value="" disabled selected>Selecione um cargo</option>
                    <option :value="corretor" v-if="checaCargoUsuario([], [cargoGerente, cargoEspecialista])">{{cargoNome}}</option>
                    <option :value="gerente" >{{lang.gerente}}</option>
                    <option :value="especialista" >Especialista Master</option>
                    <option :value="lider" >Líder</option>
                    <!--<option :value="dono"  v-if="showDono && checaCargoUsuario([],  [cargoDono])">Admin</option>-->
                    <option value="1">Admin</option>
                    <option value="6">Admin Cubix</option>
                </select>
            </div>
        </div>
        <h4 class="header2">Acesso</h4>
        <div class="row">
            <div class="input-field col s6">
                <input placeholder="usuario" id="usuario" type="text" v-model="formData.usuario">
                <label for="usuario" :class="checkValue(formData.usuario)">Usuário</label>
            </div>
            <div class="input-field col s6">
                <input id="senha" type="password" v-model="formData.senha">
                <label for="senha" :class="checkValue(formData.senha)">Senha</label>
            </div>

            <div class="col s12">
                <label>Funcionários relacionados:</label>
                <multiselect
                    label="name"
                    track-by="value"
                    open-direction="bottom"
                    placeholder="Selecione os funcionários"
                    :multiple="true"
                    :searchable="true"
                    :loading="isLoadingFuncionarios"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="false"
                    :preselect-first="false"
                    :internal-search="false"
                    :options="opcoesFuncionarios"
                    v-model="formData.funcionario_relacionamentos"
                    @search-change="findFuncionarios"
                >
                    <template v-slot:noResult>
                        <span>
                            Nenhum funcionário encontrado.
                        </span>
                    </template>
                </multiselect>
            </div>
        </div>
    </div>
</template>
<script>
    import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER, MASTER, PARCEIRO } from '@/constants/funcionarioCargo.js';
    import { get } from '@/helpers/api';
    import Auth from '@/store/auth';
    import getPalavra from '@/helpers/language';
    import { checaCargo } from '@/helpers/perfil';
    import
    {
        isMultiEmpresa
    }
    from '@/environment';
    import Multiselect from 'vue-multiselect'

    export default {
        components: { Multiselect },
        props: ['funcionario', 'usuario'],
        data: () => ({
            value: [],
            company: [],
            statusSimulador: null,
            lang: {
                gerente: getPalavra('gerente', false)
            },
            formData: {
                empresa_id: '',
                funcionario_cargo_id: '',
                usuario: '',
                senha: '',
                empresas_ids:  [],
                funcionario_relacionamentos: [],
            },
            empresas: [],
            cargoNome: 'Corretor',
            dono: DONO,
            gerente: GERENTE,
            especialista: ESPECIALISTA,
            lider: LIDER,
            cargoGerente: GERENTE,
            cargoCorretor: CORRETOR,
            cargoEspecialista: ESPECIALISTA,
            cargoParceiro: PARCEIRO,
            corretor: CORRETOR,
            showDono: false,
            opcoesFuncionarios: [],
            isLoadingFuncionarios: false,
        }),
        created: async function() {
            this.getEmpresas();

            // verifica se pode acessar componente
            if (Auth.getCargoUsuario() !== MASTER && [DONO, GERENTE, ESPECIALISTA, PARCEIRO].indexOf(Auth.getCargoUsuario()) === -1) {
                this.$router.push('/sempermissao');
            }
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;
            this.cargoEspecialista = ESPECIALISTA;
            this.cargoParceiro = PARCEIRO;

            this.showDono = isMultiEmpresa;

            if (this.funcionario) {
                this.formData.empresa_id = this.funcionario.empresa_id;
                this.formData.funcionario_cargo_id = this.funcionario.funcionario_cargo_id;

                this.formData.empresas_ids = this.funcionario.empresas.map(e => e.empresa_id)
            }
            if (this.usuario) {
                this.formData.usuario = this.usuario.usuario_username;
                this.formData.senha = '';
            }
            /* let self = this; */

            this.statusSimulador = await Auth.statusSimulador();

            // if (this.statusSimulador === 2) {
            //     this.formData.empresa_id = this.empresaId;
            // }

            const funcionarioRelacionamentos = this.funcionario.funcionario_relacionamentos
                .map(funcionarioRelacionamento => ({
                    name: funcionarioRelacionamento.funcionario_relacionado.pessoa.pessoa_nome,
                    value: funcionarioRelacionamento.funcionario_relacionado_id,
                }));
            this.formData.funcionario_relacionamentos = funcionarioRelacionamentos;
            this.opcoesFuncionarios = JSON.parse(JSON.stringify(this.formData.funcionario_relacionamentos));
        },

        computed: {
            empresaId() {
                return Auth.state.user.pessoa.funcionario.empresa_id;
            },

            empresaSelecionada(){
                return this.empresas.find( e => e.empresa_id == this.formData.empresa_id );
            },

            empresasParceiras() {
                return this.empresas.filter( empresa => empresa.empresa_tipo_id != 1)
            }

        },
        watch: {
            formData: {
                handler: function() {

                    this.$emit('input', this.formData);

                    this.$emit('newdata', [
                        this.formData.empresa_id,
                        this.formData.funcionario_cargo_id,
                        this.formData.usuario,
                        this.formData.senha,
                        this.formData
                    ]);
                },
                deep: true
            },
            'formData.empresa_id'(empresa_id){
                this.verificaEmpresaCargo();

                // this.formData.empresas_ids = [empresa_id]
            },
        },
        methods: {
            checaCargoUsuario(cargoMono, cargoMulti){
              return checaCargo(cargoMono, cargoMulti)
            },

            // recuperar a empresa selecionado no select para poder filtar se e parceira ou não
            checkEmpresaParceira(id) {

                const result = this.empresas.find(em => em.empresa_id === id);


                return result && result.empresa_tipo_id === 1;

                if (result !== null && result !== undefined){
                    if(result.empresa_tipo_id === 2) {
                        return false;
                    }
                    return true;
                }

            },

            checkValue(value) {
                if (value !== '') {
                    return 'active';
                }
                return '';
            },

            verificaEmpresaCargo(){
                let self = this;
                let encontrado = this.empresas.some(empresa => self.formData.empresa_id == empresa.empresa_id &&  empresa.empresa_tipo_id == 2)
                // if(encontrado){
                //     this.cargoNome = 'Indicador';
                // }
                // else{
                    this.cargoNome = 'Corretor';

                // }
            },

            selecionarEmpresa() {

                if (this.empresaSelecionada.empresa_tipo_id != 1) {
                    this.formData.empresas_ids = [this.formData.empresa_id]
                }
            },

            async getEmpresas(page = 0) {
                let self = this;
                await get("empresa", { params: { pagination: `${page}` } }).then((response) => {
                    let data = response.data.result.data;

                    self.company = data;
                    console.log('empresa:', self.company)
                });
            },

            findFuncionarios(name) {
                this.isLoadingFuncionarios = true;

                const params = { pessoa_nome: name };

                get("funcionario/opcoes", { params })
                 .then((response) => {
                    let data = response.data.result.data;

                    this.opcoesFuncionarios = data.map(funcionario => ({
                        name: funcionario.pessoa.pessoa_nome,
                        value: funcionario.funcionario_id,
                    }));

                    this.isLoadingFuncionarios = false;
                });
            },

            onChange:function(event){
                this.formData.empresa_id = event.empresa_id
            }

        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/usuarios/Formulario.vue